import {useEffect, useState} from 'react';
import {Link} from 'react-router';
import {getCurrentPagePath, getCurrentProjectName} from '../url';
import {Slots} from '../slots';
import {useLocation} from 'react-router-dom';

const projectName = getCurrentProjectName();

const menuItems = [
    {name: 'Home', path: '/'},
    {name: 'Showreel', path: '/showreel'},
    {name: 'Services', path: '/services'},
    {name: 'Portfolio', path: '/slots'},
    {name: 'Contact', path: '/contact'},
];

const Menu: React.FC = () => {
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [pagePath, setPagePath] = useState(getCurrentPagePath());


    useEffect(() => {

        setPagePath(getCurrentPagePath());
    }, [location.pathname]);



    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'auto';
        }

        return () => {
            document.body.style.overflowY = 'auto'; // Cleanup on unmount
        };
    }, [isMenuOpen]);

    return (
        <div
            className="bg-gradient-to-r from-gray-800 to-pink-950 via-slate-950 text-white p-8 fixed w-full z-40 top-0 left-0 shadow-lg">
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex items-center">
                    <h1 className="md:text-6xl text-3xl font-boldonse ml-2">
                        <Link to="/" key={'logo_home'}>{projectName}</Link>
                    </h1>
                </div>
                <button
                    className="md:hidden text-3xl focus:outline-none"
                    onClick={toggleMenu}
                >
                    &#9776; {/* Burger icon */}
                </button>
                <nav className="hidden md:block">
                    <ul className="flex">
                        {menuItems.map((item) => (
                            <li className="ml-4" key={`menu_${item.name}`}>
                                <Link
                                    to={item.path}
                                    key={`desktop_${item.name}`}
                                    className={`font-boldonse text-2xl hover:text-gray-300 hover:text-3xl hover:underline ${pagePath === item.path ? 'underline' : ''}`}
                                >
                                    {item.name}
                                </Link>
                            </li>))}

                    </ul>
                </nav>
            </div>
            {isMenuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-4xl text-white focus:outline-none"
                        onClick={toggleMenu}
                    >
                        &times; {/* Close icon */}
                    </button>
                    <nav>
                        <ul className="flex flex-col items-center space-y-8">
                            {menuItems.map((item) => (
                                <li key={`mobile_li_${item.name}`}>
                                    <Link
                                        to={item.path}
                                        key={`mobile_${item.name}`}
                                        className={`text-4xl font-bold hover:text-gray-300 ${pagePath === item.path ? 'text-transparent bg-clip-text bg-gradient-to-l from-pink-200 to-pink-400 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] text-7xl' : ''}`}
                                        onClick={toggleMenu}
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                            {pagePath.includes('/slot/') && (
                                <li key={`mobile_li_extra`}>
                                    <Link
                                        to={pagePath}
                                        key={`mobile_current_slot`}
                                        className={`block text-2xl mt-4 font-semibold hover:text-gray-300  text-transparent bg-clip-text bg-gradient-to-l from-pink-200 to-pink-400 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]`}
                                    >
                                        {Slots.find(slot => `/slot/${slot.id}` === pagePath)?.title || 'Current Project'}
                                    </Link>
                                </li>
                            )}
                            <li key={`mobile_li_linkedin`} className={"flex flex-row gap-5"}>
                                Follow for more
                                <a href="https://www.linkedin.com/in/lesia-k-93856a16/" target="_blank"
                                   rel="noopener noreferrer"
                                   className="hover:underline me-4 md:me-6">
                                    <img
                                        className={"w-6 h-6 invert hover:scale-110"}
                                        alt="LinkedIn"
                                        src={"/assets/linkedin.svg"}
                                    />
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            )}
        </div>
    );
};

export default Menu;
